
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinars/whatsapp-playbook",
      function () {
        return require("private-next-pages/webinars/whatsapp-playbook.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinars/whatsapp-playbook"])
      });
    }
  